import React, { useEffect, useState } from 'react';
import fetchVesselCostCentres from './queries/fetchVesselCostCentres';
import getTotalNoOfPages from '../../utils/getTotalNoOfPages';
import ApiPagination from '../common/ApiPagination';

const paginationRowList = [10, 20, 30, 40, 50];

const getRowId = (item) => (
  item?.vesselCostCenterId
  || item?.vesselCostCentreId
  || item?.id
);

const formatNameWithCode = (name, code) => {
  const displayName = (name && String(name).trim()) || '';
  const displayCode = (code != null && String(code).trim() !== '') ? String(code).trim() : '';
  if (displayName && displayCode) {
    return `${displayName} (${displayCode})`;
  }
  return displayName || displayCode || '-';
};

const formatVesselDisplay = (item) => {
  const vesselName = String(item?.vesselName || '').trim();
  const vesselCode = String(item?.vesselCode || item?.plannedVesselCode || '').trim();
  const sapVesselCompanyCode = String(
    item?.sapVesselCompanyCode || item?.vesselCompanyCode || ''
  ).trim();

  if (!vesselName && !vesselCode && !sapVesselCompanyCode) {
    return '-';
  }

  let label = vesselName;
  if (vesselCode) {
    label = label ? `${label} (${vesselCode})` : `(${vesselCode})`;
  }
  if (sapVesselCompanyCode) {
    label = label ? `${label} (${sapVesselCompanyCode})` : `(${sapVesselCompanyCode})`;
  }
  return label || '-';
};

const VesselCostCentreTable = ({
  policies,
  canManage,
  selectedIds,
  setSelectedIds,
  search,
  pageNumber,
  setpageNumber,
  rowsCount,
  setrowsCount
}) => {
  const [totalPages, settotalPages] = useState(0);

  useEffect(() => {
    if (search?.length > 2) {
      setpageNumber(1);
    }
  }, [search]);

  const reqObj = {
    pageNumber,
    rowsCount,
    search: search?.length > 2 ? search : null
  };

  const {
    isLoading,
    error,
    isFetching,
    data,
    isError
  } = fetchVesselCostCentres(reqObj);

  const listData = data?.data || {};
  const costCentres = listData?.vesselCostCenterModels
    || listData?.vesselCostCentreModels
    || listData?.items
    || listData?.data
    || [];
  const totalRowsCount = listData?.totalRowsCount || listData?.totalCount || 0;

  useEffect(() => {
    settotalPages(getTotalNoOfPages(totalRowsCount, rowsCount));
  }, [pageNumber, totalRowsCount, rowsCount]);

  useEffect(() => {
    setSelectedIds([]);
  }, [pageNumber, rowsCount, search, costCentres?.length]);

  if (isError) {
    return <>{error?.message || 'Something went wrong'}</>;
  }

  const handleRowsCount = (value) => {
    setpageNumber(1);
    setrowsCount(value);
  };

  const pageIds = (costCentres || []).map(getRowId).filter(Boolean);
  const allSelected = pageIds.length > 0 && pageIds.every((id) => selectedIds.includes(id));

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedIds((prev) => prev.filter((id) => !pageIds.includes(id)));
    } else {
      setSelectedIds((prev) => Array.from(new Set([...prev, ...pageIds])));
    }
  };

  const toggleSelectRow = (id) => {
    if (!id) return;
    setSelectedIds((prev) => (
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    ));
  };

  const canEdit = canManage === true
    || policies?.sapPoAdminPolicies?.canEdit === true
    || policies?.sapPoAdminPolicies?.canAccess === true;

  return (
    <>
      <div className={`manning-table muli expense-item vessel-cost-centre ${canEdit ? 'with-select' : ''}`}>
        <div className="table-row table-head bg-primary-50">
          {canEdit && (
            <div className="table-cell">
              <input
                type="checkbox"
                className="cost-select"
                checked={allSelected}
                onChange={toggleSelectAll}
                aria-label="Select all"
              />
            </div>
          )}
          <div className="table-cell capitalize">Company</div>
          <div className="table-cell capitalize">Vessel</div>
          <div className="table-cell capitalize">Cost Center</div>
        </div>

        <div className="table-body custom-scroll">
          {isLoading || isFetching ? (
            <h1>Loading...</h1>
          ) : (
            <>
              {costCentres && costCentres.length > 0 ? (
                costCentres.map((item) => {
                  const id = getRowId(item);
                  return (
                    <div key={id} className="table-row">
                      {canEdit && (
                        <div className="table-cell">
                          <input
                            type="checkbox"
                            className="cost-select"
                            checked={selectedIds.includes(id)}
                            onChange={() => toggleSelectRow(id)}
                            aria-label={`Select ${id}`}
                          />
                        </div>
                      )}
                      <div className="table-cell">
                        <label>
                          {formatNameWithCode(
                            item?.companyName,
                            item?.sapCompanyCode || item?.companyCode
                          )}
                        </label>
                      </div>
                      <div className="table-cell">
                        <div className="flex flex-col">
                        <label>
                          {formatVesselDisplay(item)}
                        </label>
                        <span className="text-gray-200 text-xs italic font-normal">{item?.vesselStatus || '-'}</span>
                        </div>
                      </div>
                      <div className="table-cell">
                        <label>
                          {item?.costCenter || item?.costCentre || item?.fixedCostCenter || '-'}
                        </label>
                      </div>
                    </div>
                  );
                })
              ) : (
                <h1>No Data Available</h1>
              )}
            </>
          )}
        </div>
      </div>

      {!isLoading && (
        <>
          {totalRowsCount > 5 && (
            <ApiPagination
              {...{
                setpageNumber,
                pageNumber,
                totalPages,
                paginationRowList,
                handleRowsCount,
                rowsCount
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default VesselCostCentreTable;
